<div class="flex items-center justify-center w-full">
  <div class="relative flex flex-col items-center justify-center w-full h-[102px]" appFileDragDropUpload accept="image/*" (changes)="onPhotoSelected($event)">
    <div class="flex flex-col items-center justify-center pt-5 pb-6">
      <img src="/assets/svg/image-add-fill.svg" />
      <p class="text-center text-sm text-gray-500 dark:text-gray-400" [innerHTML]="'LABEL.FILE_UPLOAD_HINT' | translate"></p>
    </div>
    <img *ngIf="photoURL" [src]="photoURL" class="absolute h-full" />
  </div>
</div>
